// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2G-NR","colMin":"styles_colMin__3riQJ"};